<div class="detail">
  <app-pit-partner-header [partner]="partner()" (selectYear)="state.selectYear($event)" />

  <app-pit-partner-indicators
    [indicators]="partner().indicators"
    [firstYear]="firstYear()"
    [windowSize]="partner().window.length"
    [debtsLevel]="debtsLevel()"
    [netWorthSeries]="netWorthSeries()"
    [liveIncomeResult]="liveIncomeResult()" />

  <app-pit-finding-list
    [findings]="partner().findings"
    [hiddenCriticalCount]="partner().hiddenCriticalCount"
    [canDismiss]="state.canUpdate()"
    [busy]="state.saving()"
    (dismiss)="onDismiss($event)"
    (undoDismiss)="onUndoDismiss($event)" />

  <!-- Abas internas (protótipo 01), no `?section=`: o conteúdo de antes, um assunto por vez. -->
  <div class="detail__sections">
    <app-pit-section-tabs
      [tabs]="tabs()"
      [active]="section()"
      (selectSection)="sections.select($event)" />

    @switch (section()) {
      @case ('assets') {
        @if (partner().assets.length) {
          <app-pit-assets-table
            [assets]="partner().assets"
            [years]="partner().window"
            [policyDefined]="policyDefined()"
            [totalRow]="totalAssetsRow()"
            [freeTotal]="partner().indicators.freeCollateral"
            [debts]="partner().debts"
            [groupRows]="partner().patrimonialMutation"
            [canEdit]="state.canUpdate()"
            (edit)="onEditAsset($event)" />
        } @else {
          <section class="pit-card">
            <p class="pit-text">Nenhum bem ou direito declarado neste ano.</p>
          </section>
        }
        @if (!partner().supportDocuments.length) {
          <p class="pit-caption detail__footnote">{{ supportDocsNote }}</p>
        }
        <p class="pit-caption detail__footnote">
          Critérios: quanto de cada bem conta como garantia segue a política de garantias definida
          na Parametrização. Participações na própria empresa, créditos contra ela, saldo em conta
          corrente, criptoativos e veículos de uso pessoal (carro, moto, aeronave, embarcação) não
          entram na capacidade de garantia; frota no nome do sócio pode ser marcada como elegível no
          Editar. "Já comprometido" vem das garantias vinculadas às operações cadastradas.
        </p>
      }
      @case ('debts') {
        <app-pit-debts-table
          [debts]="partner().debts"
          [years]="partner().window"
          [total]="partner().indicators.debts" />
      }
      @case ('mutation') {
        @if (partner().patrimonialMutation.length) {
          <app-pit-patrimonial-mutation-table
            [rows]="partner().patrimonialMutation"
            [years]="partner().window" />
        } @else {
          <section class="pit-card">
            <p class="pit-text">Sem saldos para a mutação patrimonial neste ano.</p>
          </section>
        }
      }
      @case ('income-test') {
        @if (partner().incomeTest; as test) {
          <app-pit-income-test-panel
            [test]="test"
            [canEdit]="state.canUpdate()"
            [busy]="state.saving()"
            (liveResult)="liveIncomeResult.set($event)"
            (adjust)="onAdjust($event)"
            (restore)="onRestore($event)" />
        } @else {
          <section class="pit-card">
            <h3 class="pit-title">Renda que sobra após o crescimento patrimonial</h3>
            <p class="pit-text">
              O teste precisa da declaração completa do ano (com as fichas de rendimentos e de
              bens). Só o recibo de entrega não basta: peça a declaração completa e envie ao Data
              Room.
            </p>
          </section>
        }
      }
      @case ('documents') {
        <app-pit-documents-section [supportDocuments]="partner().supportDocuments" />
      }
    }
  </div>
</div>

<app-pit-asset-edit-dialog #assetDialog />
<app-pit-dismiss-finding-dialog #dismissDialog />
